import { GrazeSpinner } from './GrazeSpinner';
import React from 'react';

export const VerticalCenteredGrazeSpinner = () => <GrazeSpinner style={{ marginTop: 'calc(50vh - 80px - 64px)' }} />;
